/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View, Text } from '@components/atoms'
import { grey, deepPurple } from '@mui/material/colors'

interface PropsType {
	value: number
	color?: string
	tooltip?: string
}

export const ProgressBar = (props: PropsType) => {
	const backgroundColor: string = props.color ?? deepPurple['A400']
	return (
		<View css={style} title={props.tooltip}>
			<View className="progressOuter">
				<View
					className="progressGage"
					css={{
						width: `${props.value}%`,
						background: backgroundColor,
					}}
				></View>
			</View>

			<Text category="c2" className="progressRate" hint="600">
				{`${props.value}%`}
			</Text>
		</View>
	)
}

const style = css({
	'.progressOuter': {
		position: 'relative',
		width: '100%',
		height: '0.5rem',
		background: grey[200],
		overflow: 'hidden',
		borderRadius: '5px',

		'.progressGage': {
			position: 'absolute',
			height: '100%',
			left: 0,
			top: 0,
			borderRadius: '5px',
		},
	},

	'.progressRate': {
		margin: 0,
	},
})
